import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';

import { getFollowUpData } from 'FRONTEND/utils/backendApi/followUpApi';

const REDUCER_NAME = 'followUp';
const consultationAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.date?.localeCompare(b.date),
});

const initialState = {
  ...consultationAdapter.getInitialState(),
  selectedConsultationId: null,
  vitalDataMap: {},
};
export const listFollowUpData = createAsyncThunk(`${REDUCER_NAME}/list`, ({ patientId, startDate, endDate }) => {
  return getFollowUpData({ patientId, startDate, endDate });
});

const followUpSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    pickConsultation: (state, { payload: { consultationId } }) => {
      state.selectedConsultationId = consultationId;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listFollowUpData.fulfilled, (state, action) => {
      consultationAdapter.setAll(state, action.payload.consultations);
      state.vitalDataMap = action.payload.data;
    });
  },
});

const CHARTABLE_VITAL_ID_LIST = [
  'oximetry',
  'glucose',
  'temperature',
  'bmi',
  'bp_diastolic',
  'bp_diastolica ',
  'bp_systolic',
  'heart_rate',
  'weight',
  'patient_weight',
  'height',
];

export const selectChartableVitals = createSelector(
  (state) => state[REDUCER_NAME].vitalDataMap,
  (vitalDataMap) => CHARTABLE_VITAL_ID_LIST.reduce((chartableVitalList, vitalId) => {
    const vitalData = vitalDataMap[vitalId];
    if (vitalData) {
      chartableVitalList.push({
        ...vitalData,
        id: vitalId,
      });
    }
    return chartableVitalList;
  }, []),
);

export const {
  selectAll: selectAllFollowUpConsultations,
  selectById: selectFollowUpConsultationById,
} = consultationAdapter.getSelectors((state) => state[REDUCER_NAME]);
export const {
  pickConsultation,
} = followUpSlice.actions;

export default followUpSlice.reducer;
